import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getStudentAction } from '../actions';

const {
  useLoaderData: useStudentLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getStudentAction,
});

function StudentLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentLoader, useStudentLoaderData };
